import React, { useState } from "react";
import { Link } from "react-router-dom";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errEmail, setErrEmail] = useState("");
  const [errPassword, setErrPassword] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const handleEmail = (e) => {
    setEmail(e.target.value);
    setErrEmail("");
  };

  const handlePassword = (e) => {
    setPassword(e.target.value);
    setErrPassword("");
  };

  const handleSignIn = (e) => {
    e.preventDefault();

    if (!email) setErrEmail("Enter your email");
    if (!password) setErrPassword("Enter your password");

    if (email && password) {
      setSuccessMsg(
        "Hello! Thank you for signing in to BigMart Hypermarket."
      );

      setEmail("");
      setPassword("");
    }
  };

  return (
    <div className="w-full h-screen flex items-center justify-center bg-gray-100">
      <div className="w-full lgl:w-1/2 h-full px-6 py-4 flex flex-col justify-center items-center">
        
        {successMsg ? (
          <div className="w-full flex flex-col justify-center items-center gap-6">
            <p className="text-green-500 font-medium text-center">
              {successMsg}
            </p>

            <Link to="/">
              <button className="w-full h-10 bg-primeColor text-white hover:bg-black duration-300">
                Go to Home
              </button>
            </Link>
          </div>
        ) : (
          <form className="w-full flex flex-col justify-center gap-6 bg-white p-6 rounded-lg shadow-md">
            
            <h1 className="text-3xl font-semibold mb-4 text-center text-primeColor">
              Sign In to BigMart Hypermarket
            </h1>

            <div className="flex flex-col gap-2">
              <label className="font-semibold">Work Email</label>
              <input
                type="email"
                value={email}
                onChange={handleEmail}
                placeholder="john@workemail.com"
                className="w-full h-10 px-3 border border-gray-400 rounded-md"
              />
              {errEmail && <p className="text-red-500">{errEmail}</p>}
            </div>

            <div className="flex flex-col gap-2">
              <label className="font-semibold">Password</label>
              <input
                type="password"
                value={password}
                onChange={handlePassword}
                placeholder="Enter your password"
                className="w-full h-10 px-3 border border-gray-400 rounded-md"
              />
              {errPassword && <p className="text-red-500">{errPassword}</p>}
            </div>

            <button
              onClick={handleSignIn}
              className="w-full h-10 bg-primeColor text-white hover:bg-black duration-300"
            >
              Sign In
            </button>

            <p className="text-center text-sm">
              Don't have an account?{" "}
              <Link to="/signup" className="text-blue-600 hover:underline">
                Sign Up
              </Link>
            </p>
          </form>
        )}

      </div>
    </div>
  );
};

export default SignIn;
